import type {PartyRole} from '@sollapay/enums';
import type {FatcaCrsBeneficiarySnapshotDTO, TrustSellerDetailsDTO} from '@sollapay/types';

/**
 * Maps the seller roster into the party-table snapshot rows shown in the activation-flow
 * supplementary declaration. Mirrors the server's `buildBeneficiarySnapshot` so the preview
 * matches what actually gets signed.
 */
export const toSellerBeneficiarySnapshots = (
  sellers: TrustSellerDetailsDTO[] | null | undefined,
  role: PartyRole
): FatcaCrsBeneficiarySnapshotDTO[] =>
  (sellers ?? []).map(seller => ({
    name: seller.fullName ?? '',
    role: seller.sellerRole ?? role,
    idOrCompanyNumber: seller.idNumber ?? '',
    birthOrIncorporationDate: seller.birthOrIncorporationDate,
    address: seller.address
  }));
